import * as React from "react";

import { cn } from "@/utils/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  inlineElement?: React.ReactNode;
  hasError?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      containerClassName,
      className,
      type,
      leadingIcon,
      trailingIcon,
      inlineElement,
      value,
      hasError,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn("relative flex items-center", containerClassName)}>
        {leadingIcon && (
          <div
            className={cn(
              "absolute left-3 flex items-center pointer-events-none transition-colors duration-200",
              value ? "text-primary" : "text-secondary"
            )}
          >
            {leadingIcon}
          </div>
        )}
        <input
          type={type}
          className={cn(
            "flex w-full pl-3 pr-2 py-[6px] text-base font-normal",
            "h-9 bg-surface-field-default",
            "rounded-lg outline-none shadow-field",
            "transition-all duration-200 ease-in-out",
            "border-0",
            "disabled:cursor-not-allowed disabled:bg-surface-fields-disabled disabled:border-border-field-disabled disabled:shadow-none",
            "placeholder:text-tertiary",
            hasError
              ? "border-[0.5px] border-border-field-error hover:border-border-field-error-hover focus:border-border-field-error-focus focus:bg-surface-focus-selected focus:shadow-field-focus"
              : "border-[0.5px] border-border-field-default hover:border-border-field-hover focus:border-border-field-focus focus:bg-surface-focus-selected focus:shadow-field-focus",
            leadingIcon && "pl-10",
            trailingIcon && "pr-10",
            className
          )}
          ref={ref}
          value={value}
          {...props}
        />
        {trailingIcon && (
          <div
            className={cn(
              "absolute right-3 flex items-center pointer-events-none transition-colors duration-200",
              value ? "text-primary" : "text-secondary"
            )}
          >
            {trailingIcon}
          </div>
        )}
        {inlineElement && (
          <div className="absolute right-3 flex items-center">
            {inlineElement}
          </div>
        )}
      </div>
    );
  }
);

export default Input;
